import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { DashboardProvider } from '@providers/dashboard/dashboard'
import { AuthProvider } from '@providers/auth/auth';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { ASSETS } from '@env';
import { FortalezasDebilidadesPage, TabsPage, VsPage } from '@pages';
import { LoadingProvider } from '@providers/loading/loading';
import { CampaignsProvider }  from '@providers/campaigns/campaigns';
import { CampaignActiveComponent } from '../../components/campaign-active/campaign-active';
import { UserInfoComponent } from '../../components/user-info/user-info';
import { TranslateService } from '@ngx-translate/core';
import { ColorProvider } from '@providers/color/color';
import { Events } from 'ionic-angular';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})

export class HomePage implements AfterViewInit {

  labelTotal: string;
  labelTipo: string;
  labelIncorrectas: string;
  labelCorrectas: string;

  pieChartData =  {
    chartType: 'PieChart',
    dataTable: [
      ['Tipo', 'Total'],
      ['Incorrectas',0],
      ['Correctas',0]
    ],
    options: {
       legend: 'none',
       slices: {
          0: { color: '#EA3A71' },
          1: { color: '#8C41D' }
        },
        chartArea: { top:12,width:'50%',height:'90%'},
        height: '185'
    }
  };
  jugador: Jugador;
  equipo: Equipo;
  ICONS_CATEGORIES = ASSETS.ICONS_CATEGORIES;

  jugadorGanados: any;
  jugadorGanadosRequest: Boolean = true;
  jugadorPerdidos: any;
  jugadorPerdidosRequest: Boolean = true;
  jugadorJugados: any;
  jugadorJugadosRequest: Boolean = true;

  retos: any;
  retosRequest: Boolean = true;

  efectividad: any;
  efectividadRequest: Boolean = true;

  categorias: any;
  categoriasRequest: Boolean = true;

  copas: any;
  copasRequest: Boolean = true;

  tab: string = 'campaign';
  campaign: any = null;
  @ViewChild('main', { read: ElementRef }) main: ElementRef;
  @ViewChild(CampaignActiveComponent) campaignComponent: CampaignActiveComponent;
  @ViewChild(UserInfoComponent) header: UserInfoComponent;

  primaryColor: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private app: App,
    private dashboardProvider: DashboardProvider,
    private loadingProvider: LoadingProvider,
    private campaignsProvider: CampaignsProvider,
    private authProvider: AuthProvider,
    private translateService: TranslateService,
    private colorProvider: ColorProvider,
    private events: Events
  ) {


    this.labelTotal       = this.translateService.instant('home.chart.total');
    this.labelTipo        = this.translateService.instant('home.chart.tipo');
    this.labelIncorrectas = this.translateService.instant('home.chart.incorrectas');
    this.labelCorrectas   = this.translateService.instant('home.chart.correctas');


    this.pieChartData =  {
      chartType: 'PieChart',
      dataTable: [
        [this.labelTipo, this.labelTotal],
        [this.labelIncorrectas,0],
        [this.labelCorrectas,0]
      ],
      options: {
         legend: 'none',
         slices: {
            0: { color: '#EA3A71' },
            1: { color: this.primaryColor }
          },
          chartArea: { top:12,width:'50%',height:'90%'},
          height: '185'
      }
    };

  }

  ionViewDidLoad() {
    this.initRequest();
  }

  async ngAfterViewInit() {
    
    this.updateColors();
    this.events.subscribe('color:updated', async () => {
      this.updateColors();
    });
    
    // this.campaignsProvider.get()
    //   .then( campaign => {
    //     if(campaign) {
    //       this.main.nativeElement.style.backgroundImage = "url('assets/imgs/subheader-campaign.svg')";
    //       this.main.nativeElement.style.height = "250px";
    //     } else {
    //       this.main.nativeElement.style.backgroundImage = "none" ;
    //       this.main.nativeElement.style.height = "auto";
    //     }
    //   })
    //   .catch( e => {
    //     this.main.nativeElement.style.backgroundImage = "none";
    //     this.main.nativeElement.style.height = "auto";
    //   });
  }

  async updateColors() {
    this.primaryColor = await this.colorProvider.getPrimaryColor();
  }

  segmentChanged(ev) {
    this.initRequest();
  }

  async initRequest(refresher = null) {
    this.jugadorGanadosRequest = true;
    this.jugadorPerdidosRequest = true;
    this.jugadorJugadosRequest = true;

    try {
      this.jugador  = await this.authProvider.getSession();
      this.equipo   = await this.authProvider.getEquipo();

      await this._verificaCampania();

      if(!this.campaign) {
        this.tab = 'global'
      }

      this._updateScore();
      this.getRetos();
      this.getEfectividad();
      this.getCategorias();
      this.getCopas();
      this.masRetosPerdidos();
      this.masRetosJugados();
      this.masRetosGanados();

    } catch (e) {
      console.log(e);
    } finally {

      if ( refresher ) {
        refresher.complete();
      }
    }

  }

  private async _updateScore(){
    // try {
    //   await this.header.updateScore();
    // } catch( e ) {
    //   console.log('_updateScore', e);
    // }
  }

  private async _verificaCampania() {
    this.campaign = await this.campaignsProvider.get();
  }

  private async getRetos() {
    this.retosRequest = true;
    try {
      this.retos = await this.dashboardProvider.getPreguntas(this.equipo.area._id, this.equipo._id, this.jugador._id, this.tab == 'campaign' ? this.campaign._id: null);

      this.pieChartData =  {
        chartType: 'PieChart',
        dataTable: [
          [this.labelTipo, this.labelTotal],
          [this.labelIncorrectas, this.retos.perdidos],
          [this.labelCorrectas,  this.retos.ganados]
        ],
        options: {
           legend: 'none',
           slices: {
              0: { color: '#EA3A71' },
              1: { color: this.primaryColor } // custom color
            },
            chartArea: { top:12,width:'50%',height:'90%'},
            height: '185'
        }
      };

    } catch(e) {
      console.log(e);
    } finally {
      this.retosRequest = false;
    }
  }

  private async getEfectividad() {
    this.efectividadRequest = true;
    try {
      this.efectividad = await this.dashboardProvider.getEfectividad(this.equipo.area._id, this.equipo._id, this.jugador._id, this.tab == 'campaign' ? this.campaign._id: null);

    } catch(e) {
      console.log(e);
    } finally {
      this.efectividadRequest = false;
    }
  }

  private async getCategorias() {
    this.categoriasRequest = true;
    try {
      this.categorias = await this.dashboardProvider.getCategorias(this.equipo.area._id, this.equipo._id, this.jugador._id, this.tab == 'campaign' ? this.campaign._id: null);

    } catch(e) {
      console.log(e);
    } finally {
      this.categoriasRequest = false;
    }
  }

  private async getCopas() {
    this.copasRequest = true;
    try {
      this.copas = await this.dashboardProvider.getCopas(this.equipo.area._id, this.equipo._id, this.jugador._id);

    } catch(e) {
      console.log(e);
    } finally {
      this.copasRequest = false;
    }
  }

  private async masRetosPerdidos() {
    try {
      this.jugadorPerdidos = await this.dashboardProvider.masRetosPerdidos(this.equipo.area._id, this.jugador._id, this.tab == 'campaign' ? this.campaign._id: null);

    } catch(e) {
      console.log(e);
    } finally {
      this.jugadorPerdidosRequest = false;
    }
  }

  private async masRetosJugados() {
    try {
      this.jugadorJugados = await this.dashboardProvider.masRetosJugados(this.equipo.area._id, this.jugador._id, this.tab == 'campaign' ? this.campaign._id: null);

    } catch(e) {
      console.log(e);
    } finally {
      this.jugadorJugadosRequest = false;
    }
  }

  private async masRetosGanados() {
    try {
      this.jugadorGanados = await this.dashboardProvider.masRetosGanados(this.equipo.area._id, this.jugador._id, this.tab == 'campaign' ? this.campaign._id: null);
    } catch(e) {
      console.log(e);
    } finally {
      this.jugadorGanadosRequest = false
    }
  }

  verDetalleCategorias() {
    this.loadingProvider.show(true);
    this.navCtrl.push(FortalezasDebilidadesPage, {
      jugador: this.jugador,
      equipo: this.equipo,
      campania: this.campaign,
    });
  }

  retosPersonales() {
    this.app.getRootNavs()[0].setRoot(TabsPage, {
      active: 0
    });
  }

  detalle(oponente) {
    this.loadingProvider.show(true);
    this.navCtrl.push(VsPage,{
      jugador: this.jugador,
      oponente: oponente.jugador,
      equipo: this.equipo
    });
  }

  close() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts